export default "__VITE_ASSET__cd2778f3__"